var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm._m(0), _vm.currentQuestion ? _c('b-collapse', {
    key: _vm.currentQuestion.question,
    attrs: {
      "visible": "",
      "appear": _vm.isNotFirstQuestion
    }
  }, [_c('b-alert', {
    attrs: {
      "show": _vm.hasSaveError,
      "fade": "",
      "variant": "danger"
    }
  }, [_vm._v(" Fout bij het opslaan van het antwoord op de vraag. Probeer het opnieuw of "), _c('b-button', {
    staticClass: "p-0",
    attrs: {
      "variant": "link"
    },
    on: {
      "click": _vm.nextQuestion
    }
  }, [_vm._v("sla deze vraag over")]), _vm._v(". ")], 1), _c('b-alert', {
    attrs: {
      "show": _vm.hasIsRequiredError,
      "fade": "",
      "variant": "warning"
    }
  }, [_vm._v(" Er is iets misgegaan bij het ophalen van de controlevraag uit de PIM. Beantwoord daarom a.u.b. mogelijk nogmaals deze vraag. ")]), _c('b-overlay', {
    attrs: {
      "show": _vm.isSaving,
      "rounded": "sm",
      "spinner-variant": "primary"
    }
  }, [_c('b-card', {
    attrs: {
      "no-body": ""
    }
  }, [_c('b-card-header', [_c('h6', {
    staticClass: "m-0",
    domProps: {
      "innerHTML": _vm._s(_vm.currentQuestion.question)
    }
  })]), _c('b-card-body', [_c('form', {
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.answerCurrentQuestion.apply(null, arguments);
      }
    }
  }, [_vm.currentQuestion.valueType === 'boolean' ? _c('div', {
    staticClass: "text-center"
  }, [_c('b-button', {
    staticClass: "mr-4",
    attrs: {
      "type": "submit",
      "variant": "success"
    },
    on: {
      "click": function ($event) {
        _vm.currentQuestion.answer = true;
      }
    }
  }, [_vm._v("Ja")]), _c('b-button', {
    attrs: {
      "type": "submit",
      "variant": "danger"
    },
    on: {
      "click": function ($event) {
        _vm.currentQuestion.answer = false;
      }
    }
  }, [_vm._v("Nee")])], 1) : _vm.currentQuestion.valueType === 'number' ? _c('div', [_c('b-input', {
    staticClass: "d-inline-block mr-2",
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "autofocus": "",
      "required": "",
      "autocomplete": "off",
      "type": "number"
    },
    model: {
      value: _vm.currentQuestion.answer,
      callback: function ($$v) {
        _vm.$set(_vm.currentQuestion, "answer", _vm._n(typeof $$v === 'string' ? $$v.trim() : $$v));
      },
      expression: "currentQuestion.answer"
    }
  }), _c('b-button', {
    attrs: {
      "type": "submit",
      "variant": "primary"
    }
  }, [_vm._v("OK")])], 1) : _c('div', [_c('b-input', {
    staticClass: "d-inline-block mr-2",
    staticStyle: {
      "width": "211px"
    },
    attrs: {
      "autofocus": "",
      "required": "",
      "autocomplete": "off",
      "type": "text"
    },
    model: {
      value: _vm.currentQuestion.answer,
      callback: function ($$v) {
        _vm.$set(_vm.currentQuestion, "answer", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "currentQuestion.answer"
    }
  }), _c('b-button', {
    attrs: {
      "type": "submit",
      "variant": "primary"
    }
  }, [_vm._v("OK")])], 1)])])], 1)], 1)], 1) : _vm._e()], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('strong', {
    staticClass: "text-black-50 d-block mb-3"
  }, [_c('i', [_vm._v("Geef extra informatie over het product")])]);

}]

export { render, staticRenderFns }